import ImageCarousel from "../ImageCarousel/ImageCarousel";
import "./Home.css"

export default function What() {
  return (
    <div>
      <div className="section">
        <div className="image-carousel-container">
          <div className="image-container intro-box">
            <div className="width-60">
              <p>Moin und willkommen beim Muza Store!
                Bei uns findet ihr liebevoll ausgewählte, natürliche Produkte und besondere Vintage-Unikate
                mit Charakter. Entdeckt die handverlesenen Schätze von charmanten Industrielampen über nordische
                Textilien bis hin zu lebendigen Zimmerpflanzen. Unser Geschäft findet ihr im historischen Hessenstein
                Turm in der Holsteinischen Schweiz an der Ostsee.
              </p>
              <p>Kommt vorbei, stöbert und lasst euch inspirieren!</p>
            </div>
          </div>
        </div>
      </div>
      <div className="section">
        <ImageCarousel />
      </div>
    </div>
  );
}
